import { Route, Routes } from "react-router-dom";
import Login from "../../pages/corporateAdmin/auth/Login";
import Dashboard from "../../pages/corporateAdmin/Dashboard";
import Admin from "../../pages/corporateAdmin/Admin";
import Meals from "../../pages/corporateAdmin/reports/Meals";
import Revenue from "../../pages/corporateAdmin/reports/Revenue";
import TopSelling from "../../pages/corporateAdmin/reports/TopSelling";
import Employee from "../../pages/corporateAdmin/reports/Employee";
import NoUsage from "../../pages/corporateAdmin/reports/NoUsage";
import Common from "../../pages/corporateAdmin/Common";
import ForgotPassword from "../../pages/corporateAdmin/auth/ForgotPassword";
import Vendor from "../../pages/corporateAdmin/Vendor/Vendor";
import VendorStaff from "../../pages/corporateAdmin/Vendor/VendorStaff";
import GalleryList from "../../pages/corporateAdmin/gallery/GalleryList";
import MenuPricing from "../../pages/corporateAdmin/menu-pricing/MenuPricing";
import ExcelImportProducts from "../../pages/corporateAdmin/product/ExcelImportProducts";
import CafeteriaInventory from "../../pages/corporateAdmin/cafeteria-inventory/CafeteriaInventory";
import VendorCompliance from "../../pages/corporateAdmin/vendorCompliance/VendorCompliances";


const CorporateAdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/admins" element={<Admin />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/vendor" element={<Vendor />} />
      <Route path="/vendor-manager" element={<VendorStaff />} />
      <Route path="/vendor-manager/:id" element={<VendorStaff />} />
      <Route path="/gallery" element={<GalleryList />} />

      <Route path="/menu-pricing" element={<MenuPricing />} />
      <Route path="/excel-products/:id" element={<ExcelImportProducts />} />
      <Route path="/excel-products" element={<ExcelImportProducts />} />
      <Route path="/cafeteria-inventory" element={<CafeteriaInventory />} />
      <Route path="/vendor-compliance" element={<VendorCompliance />} />

      <Route path="/meals" element={<Meals />} />
      <Route path="/revenues" element={<Revenue />} />
      <Route path="/top-selling-products" element={<TopSelling />} />
      <Route path="/emp-feed" element={<Employee />} />
      <Route path="/no-of-app-users" element={<NoUsage />} />

      <Route path="/common" element={<Common />} />
      <Route path="/common2" element={<Common />} />
      <Route path="/common3" element={<Common />} />
      <Route path="/common4" element={<Common />} />
      <Route path="/common5" element={<Common />} />

    </Routes>
  );
};
export default CorporateAdminRoutes;
